import { select, call, put, fork } from "redux-saga/effects";
import * as viewActions from "actions/view";
import { selectAccountId } from "reducers/account/meta";
import { selectUserView } from "selectors/view";
import * as firebase from "sagas/firebase/lib";
import { throttleBy } from "utils/sagas";
import { FLUSH_VIEW_TO_FIREBASE } from "constants/view/actionTypes";

export function* replaceAccountView(res) {
  const { key, data } = res;
  yield put(viewActions.replaceAccountView(key, data));
}

export function* replaceAccountViews(res) {
  const { data } = res;
  yield put(viewActions.replaceAccountViews(data || {}));
}

export function* flushViewToFirebase(action) {
  const { userId } = action.payload;

  const accountId = yield select(selectAccountId);
  const view = yield select(selectUserView);

  if (view) {
    yield call(
      firebase.set,
      `accounts/${accountId}/views/users/${userId}`,
      view
    );
  }
}

export default function* views() {
  yield fork(
    throttleBy,
    "userId",
    500,
    FLUSH_VIEW_TO_FIREBASE,
    flushViewToFirebase
  );
}
